// removed by extract-text-webpack-plugin
module.exports = {"passwordForgot":"login_passwordForgot_1vcDg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/login/login.scss
// module id = 1551
// module chunks = 0